// ABOUTME: Route guard that restricts access to self-service users only.
// ABOUTME: Redirects enterprise/sales-led users to the home page.

import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { LoadingSpinner } from '@/components/ui/LoadingSpinner';

interface SelfServiceRouteProps {
  children: ReactNode;
}

/**
 * Route guard for pages that only self-service users should access (pricing, upgrade).
 * Enterprise and sales-led users are redirected to the home page since they manage
 * their plans through sales, not self-service UI.
 *
 * This wraps ProtectedRoute — authentication is handled by the parent route.
 */
export function SelfServiceRoute({ children }: SelfServiceRouteProps) {
  const { isSelfService, isLoadingWorkspaces } = useApp();

  if (isLoadingWorkspaces) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  if (!isSelfService) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
